<app-key-combo-button
  icon="fas fa-search"
  [outlined]="false"
  size="small"
  label="Suche starten ..."
  [keys]="['control', '.']"
  styleClass="p-button-shade"
  (action)="visible = true"></app-key-combo-button>

<p-dialog
  styleClass="z-top"
  maskStyleClass="z-top"
  appendTo="body"
  header="Header"
  [(visible)]="visible"
  position="top"
  [style]="{ width: '80rem' }">
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3 w-full">
      <app-search-input
        [autofocus]="true"
        placeholder="durchsuchen ..."
        (search)="updateQueryString($event)"></app-search-input>
      <app-tag-filter-dropdown
        styleClass="w-20rem"
        (selectedTagsChange)="updateQueryTags($event)"
        [selectedTags]="queryTags"
        [tagsInUse]="globalSearchStore.tagsInUse()" />

      <p-iconField>
        <p-inputIcon styleClass="fas fa-folder"></p-inputIcon>
        <p-treeSelect
          class="w-20rem"
          placeholder="Indikatoren durchsuchen ..."
          containerStyleClass="w-full"
          [(ngModel)]="queryCategory"
          (onNodeSelect)="callCategorySearch($event)"
          (onClear)="callCategorySearch()"
          [resetFilterOnHide]="true"
          [showClear]="true"
          [filter]="true"
          [options]="tree">
        </p-treeSelect>
      </p-iconField>

      <p-button
        class="ml-auto mr-3"
        [disabled]="!queryString && !queryTags.length && !queryCategory"
        icon="fas fa-filter-circle-xmark"
        [rounded]="true"
        [outlined]="true"
        (click)="resetQuery()"
        label="zurücksetzen"></p-button>
    </div>
  </ng-template>

  @if (results) {
    <p-tabMenu
      [model]="tabs"
      [activeItem]="activeTab"
      (activeItemChange)="onActiveItemChange($event)">
      <ng-template pTemplate="item" let-item>
        <a pRipple class="flex align-items-center gap-2 p-menuitem-link">
          <i [class]="item.icon"></i>
          <span class="font-bold">
            {{ item.label }}
          </span>
          <p-badge [value]="results[item.key].length" />
        </a>
      </ng-template>
    </p-tabMenu>
    @if (active && results[active] && results[active].length) {
      <p-table
        [value]="results[active]"
        [paginator]="results[active].length > 10"
        [rows]="10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[10, 25, 50]">
        <ng-template pTemplate="body" let-item>
          <tr
            *ngIf="active === 'indicators'"
            app-table-row-indicator
            [fullName]="true"
            [item]="item"
            [actions]="['select', 'edit']"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'dataLayerTypes'"
            app-table-row-data-layer-type
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'bookmarks'"
            app-table-row-bookmark
            [actions]="['openInAtlas']"
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'colorsets'"
            app-table-row-colorset
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'topics'"
            app-table-row-topic
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'stories'"
            app-table-row-story
            [item]="item"
            (closeEvent)="close()"></tr>
        </ng-template>
      </p-table>
    }
  } @else {
    <app-alert [canToggle]="false">
      Suchen Sie nach Indikatoren, Räume, Ansichten oder Dokumentationen und
      führen Schnelle Funktionen durch.
    </app-alert>
  }

  <ng-template pTemplate="footer">
    <p-button
      class="mr-auto flex"
      icon="fas fa-times"
      [rounded]="true"
      label="schließen"
      severity="secondary"
      [outlined]="true"
      (onClick)="close()" />
  </ng-template>
</p-dialog>
<app-mask [visible]="!!visible" (click)="close()"></app-mask>
